export { default } from './ContentTitle';
